import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { FacilitiesListComponent } from './facilities-list/facilities-list.component';
import { FacilitiesCreateComponent } from './facilities-create/facilities-create.component';


const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'list',
        component: FacilitiesListComponent,
        data: {
          title: "Facilities List",
          breadcrumb: "Facilities List"
        }
      },
      {
        path: 'create',
        component: FacilitiesCreateComponent,
        data: {
          title: "Create Facilities",
          breadcrumb: "Create Facilities"
        }
      },
      {
        path: 'edit/:id',
        component: FacilitiesCreateComponent,
        data: {
          title: "Edit Facilities",
          breadcrumb: "Edit Facilities"
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})

export class FacilitiesRoutingModule { }
